import { useState } from 'react'

import {
  getPrincipalsManagerFullNames,
  getPrincipalsOrganizationNamesWithInn,
  getRepresentativesNamesWithInn,
  PoaItem,
} from '@builddocs/data-management'
import { Typography, Tag, Descriptions, Button } from 'antd'

const statusMap: Record<string, { color: string; label: string }> = {
  valid: { color: 'success', label: 'Валидный' },
  underVerification: { color: 'warning', label: 'Ожидает проверки' },
  invalid: { color: 'error', label: 'Не валидный' },
  init: { color: 'warning', label: 'Ожидает проверки' },
}

const formatDate = (date: string) => {
  if (!date) return ''
  return new Date(date).toLocaleDateString('ru-RU')
}

type ProxyCardProps = {
  proxy: PoaItem
}

export const ProxyCard = ({ proxy }: ProxyCardProps) => {
  const [isShowPowers, setIsShowPowers] = useState(false)
  const status = statusMap[proxy.status] || statusMap['init']

  const handleShowPower = () => {
    setIsShowPowers(!isShowPowers)
  }

  const principalsManagerFullNames = getPrincipalsManagerFullNames(proxy)
  const representativesNamesWithInn = getRepresentativesNamesWithInn(proxy)
  const principalsOrganizationNamesWithInn =
    getPrincipalsOrganizationNamesWithInn(proxy)

  return (
    <div
      style={{
        background: '#f6f8fb',
        borderRadius: 12,
        padding: 20,
        marginTop: 16,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: 8,
        }}
      >
        <Typography.Text strong style={{ fontSize: 16 }}>
          {proxy?.poaName ?? '-'}
        </Typography.Text>

        <Tag color={status.color}>{status.label}</Tag>
        <Typography.Text
          style={{ marginLeft: 16, fontSize: 12 }}
          type="secondary"
        >
          Доверенность прошла проверку:&nbsp;
          {formatDate(proxy?.statusUpdatedAt ?? '-')}
        </Typography.Text>
      </div>
      <Descriptions
        column={1}
        size="small"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        <Descriptions.Item label="Номер доверенности">
          {proxy?.poaNumber ?? '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Доверитель">
          {principalsOrganizationNamesWithInn}
        </Descriptions.Item>
        <Descriptions.Item label="ФИО доверителя">
          {principalsManagerFullNames}
        </Descriptions.Item>
        <Descriptions.Item label="Дата выдачи">
          {formatDate(proxy?.issued ?? '-')}
        </Descriptions.Item>
        <Descriptions.Item label="Срок действия">
          {formatDate(proxy?.validUntil ?? '-')}
        </Descriptions.Item>
        <Descriptions.Item label="ФИО доверенного лица">
          {representativesNamesWithInn}
        </Descriptions.Item>
      </Descriptions>
      <Button
        style={{ color: '#2e5bff', fontSize: 14, padding: 0 }}
        type="link"
        onClick={handleShowPower}
      >
        Полномочия&nbsp;
        <svg
          fill="none"
          height="6"
          style={{
            transform: isShowPowers ? 'rotate(180deg)' : 'none',
          }}
          viewBox="0 0 10 6"
          width="10"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 4L1 0L0 1L5 6L10 1L9 0L5 4Z"
            fill="#0034AD"
            fillRule="evenodd"
          />
        </svg>
      </Button>
      {isShowPowers && (
        <Descriptions column={1} size="small">
          <Descriptions.Item label="Из классификатора">
            {proxy?.permissions?.dictionary?.length
              ? proxy?.permissions?.dictionary
                  .map(permission => permission.name)
                  .join(', ')
              : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Текстовые полномочия">
            {proxy?.permissions?.text ?? '-'}
          </Descriptions.Item>
        </Descriptions>
      )}
    </div>
  )
}
